module.exports = __webpack_public_path__ + "media/images/japan/useful_1-46697e9fb5920e1bdbc1672e82ea9e5b.jpg";